import CommonPage from "../CommonPage";
import { Card, Link } from "../../components";
import { Grid, Skeleton, styled, Tab, Tabs } from "@mui/material";
import React from "react";
import { transientOptions } from "../../styles/theme";
import formatters from "../../utils/formatters";
import PropostasTabConnected from "./PropostasTab.connected";
import { EmailRounded, WhatsApp } from "@mui/icons-material";
import DocumentosTabConnected from "./DocumentosTab.connected";
import DadosOperacaoTabConnected from "./DadosClienteTab.connected";
import ClienteHeaderConnected from "../../components/presentation/ClienteHeader.connected";

const SkeletonCard = styled(Skeleton)`
  width: 100%;
  height: 239px;
  border-radius: 1rem;
`;

const DetalhesClientePage = ({
  loading,
  data,
  tab,
  perfil,
  handleTabChange,
}) => {
  const isLoading = !!loading || !data;

  return (
    <CommonPage selected={"clientes"}>
      {isLoading && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SkeletonCard variant={"rectangular"} />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <SkeletonCard variant={"rectangular"} />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <SkeletonCard variant={"rectangular"} />
          </Grid>
        </Grid>
      )}
      {!isLoading && (
        <Grid container spacing={3}>
          <ClienteHeaderConnected handleTabChange={handleTabChange} tab={tab} cliente={data} />
          {tab === "0" && <PropostasTabConnected />}
          {tab === "1" && <DadosOperacaoTabConnected />}
          {tab === "2" && <DocumentosTabConnected />}
        </Grid>
      )}
    </CommonPage>
  );
};

export default DetalhesClientePage;
